import moment from "moment";

export const exportExpenseExcelOnClick = (expenseList = []) => {
  const companyId = JSON.parse(localStorage.getItem("data")).hrmsCompanyId;
  const departmentDisplayName =
    JSON.parse(localStorage.getItem("Templatedata")).find(
      (label) => label.actualName === "Department"
    )?.displayName || "Department";

  let tableHTML = `
    <table style="border-collapse: collapse; font-family: Arial; font-size: 12px; width: 100%;">
      <thead>
        <tr>
          <th style="color: #fff; background-color: #32577e; text-align: center; vertical-align: middle; padding: 5px 8px;" align="center">S.No</th>
          <th style="color: #fff; background-color: #32577e; text-align: center; vertical-align: middle; padding: 5px 8px;" align="center">Create Date</th>
          <th style="color: #fff; background-color: #32577e; text-align: center; vertical-align: middle; padding: 5px 8px;" align="center">Expense Date</th>
          <th style="color: #fff; background-color: #32577e; text-align: center; vertical-align: middle; padding: 5px 8px;" align="center">Emp. Name</th>
          <th style="color: #fff; background-color: #32577e; text-align: center; vertical-align: middle; padding: 5px 8px;" align="center">Emp. Code</th>
          <th style="color: #fff; background-color: #32577e; text-align: center; vertical-align: middle; padding: 5px 8px;" align="center">${departmentDisplayName}</th>
          <th style="color: #fff; background-color: #32577e; text-align: center; vertical-align: middle; padding: 5px 8px;" align="center">${
            companyId == 14 ? "Party Details" : "Meeting Details"
          }</th>
          <th style="color: #fff; background-color: #32577e; text-align: center; vertical-align: middle; padding: 5px 8px;" align="center">Type</th>
          <th style="color: #fff; background-color: #32577e; text-align: center; vertical-align: middle; padding: 5px 8px;" align="center">Applied Amount(₹)</th>
          <th style="color: #fff; background-color: #32577e; text-align: center; vertical-align: middle; padding: 5px 8px;" align="center">Approved Amount(₹)</th>
          <th style="color: #fff; background-color: #32577e; text-align: center; vertical-align: middle; padding: 5px 8px;" align="center">Deviated Amount(₹)</th>
          <th style="color: #fff; background-color: #32577e; text-align: center; vertical-align: middle; padding: 5px 8px;" align="center">${
            companyId == 14 ? "Descriptions" : "Remarks"
          }</th>
          <th style="color: #fff; background-color: #32577e; text-align: center; vertical-align: middle; padding: 5px 8px;" align="center">Status</th>
          <th style="color: #fff; background-color: #32577e; text-align: center; vertical-align: middle; padding: 5px 8px;" align="center">Attached Bill</th>
        </tr>
      </thead>
      <tbody>
  `;

  expenseList.forEach((data, index) => {
    const rowStyle =
      data.expenseStatus === "APPROVED"
        ? "background-color: rgb(50, 164, 114); color: #fff;"
        : data.expenseStatus === "REJECTED"
        ? "background-color: rgb(233, 75, 97); color: #fff;"
        : "";

    const appliedAmount =
      data.appliedAmount !== null ? data.appliedAmount.toFixed(2) : "0.00";
    const approvedAmount =
      data.approvedAmount !== null ? data.approvedAmount.toFixed(2) : "0.00";
    const deviation =
      data.appliedAmount && data.approvedAmount
        ? (data.appliedAmount - data.approvedAmount).toFixed(2)
        : "0.00";

    const attachedLinks = (data?.userFileExpenseDto || []).map(
      (item) => `<a href="${item.fileUrl}" target="_blank">${item.fileUrl}</a>`
    );

    tableHTML += `
      <tr style="${rowStyle}">
      <tr></tr>
        <td style="text-align: center; vertical-align: middle; padding: 5px 8px;" align="center">${
          data.communicationId ? `M ${index + 1}` : index + 1
        }</td>
        <td style="text-align: center; vertical-align: middle; padding: 5px 8px;" align="center">${moment(
          data.createdAt
        ).format("DD-MM-YYYY")}</td>
        <td style="text-align: center; vertical-align: middle; padding: 5px 8px;" align="center">${moment(
          data.expenseDate
        ).format("DD-MM-YYYY")}</td>
        <td style="text-align: center; vertical-align: middle; padding: 5px 8px;" align="center">${
          data.userName || "NA"
        }</td>
        <td style="text-align: center; vertical-align: middle; padding: 5px 8px;" align="center">${
          data.userEmpCode || "NA"
        }</td>
        <td style="text-align: center; vertical-align: middle; padding: 5px 8px;" align="center">${
          data.departmentName || "NA"
        }</td>
        <td style="text-align: center; vertical-align: middle; padding: 5px 8px;" align="center">${
          data.clientName || "NA"
        }</td>
        <td style="text-align: center; vertical-align: middle; padding: 5px 8px;" align="center">${
          data.hrmsExpenseTypeDto?.hrmsExpenseName || "NA"
        }</td>
        <td style="text-align: center; vertical-align: middle; padding: 5px 8px;" align="center">
          <div style="display: flex; align-items: center; justify-content: center; gap: 10px;">
            <span>${appliedAmount}</span>
          </div>
        </td>
        <td style="text-align: center; vertical-align: middle; padding: 5px 8px;" align="center">
          <div style="display: flex; align-items: center; justify-content: center; gap: 10px;">
            <span>${approvedAmount}</span>
          </div>
        </td>
        <td style="text-align: center; vertical-align: middle; padding: 5px 8px;" align="center">${deviation}</td>
        <td style="text-align: center; vertical-align: middle; padding: 5px 8px;" align="center">${
          data.remarks?.trim() || "NA"
        }</td>
        <td style="text-align: center; vertical-align: middle; padding: 5px 8px;" align="center">${
          data.expenseStatus
            ? data.isAmountDeviation
              ? `${data.expenseStatus} (Amount Deviated)`
              : data.expenseStatus
            : "NA"
        }</td>
        <td style="text-align: center; vertical-align: middle; padding: 5px 8px;" align="center">${
          attachedLinks || "NA"
        }</td>
      </tr>
    `;
  });

  tableHTML += `</tbody></table>`;

  const blob = new Blob(
    [
      `\ufeff<html xmlns:o="urn:schemas-microsoft-com:office:office"
         xmlns:x="urn:schemas-microsoft-com:office:excel"
         xmlns="http://www.w3.org/TR/REC-html40">
        <head><meta charset="UTF-8"></head>
        <body>${tableHTML}</body></html>`,
    ],
    { type: "application/vnd.ms-excel" }
  );

  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = `Expense.xls`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
